import {Component, inject, Signal} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {Language} from 'bs-components';
import {LanguagesService} from '../../core/services/languages.service';
import {NgClass} from '@angular/common';
import {DateFormatService} from '../../core/services/date-format.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  imports: [TranslatePipe, NgClass],
})
export class SettingsComponent {
  readonly translate = inject(TranslateService);
  private readonly dateService = inject(DateFormatService);
  private readonly langService = inject(LanguagesService);

  public readonly dateFormats = this.dateService.dateFormats;
  public readonly userDateFormat$ = this.dateService.userDateFormat$;

  public readonly languages$: Signal<Language[]> = this.langService.languages$;
  public readonly currentLanguage$: Signal<Language> = this.langService.currentLanguage$;

  changeLanguage(language: string) {
    this.translate.use(language);
    this.langService.update(language).subscribe();
  }

  changeDateFormat(format: string) {
    this.dateService.updateDateFormat(format).subscribe();
  }
}
